// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 421 ? "4286a96f" : chunkId) + "." + {"308":"828ca390b686f0a9","421":"3fa6b3c992167477","469":"2546cde8322f0f12","629":"f813949c51a3032b","650":"7814abca7818ca7d","697":"058b02fe8a5635e6"}[chunkId] + ".js";
};